module.exports = __webpack_public_path__ + "static/media/award.92532bed.svg";